import { render, staticRenderFns } from "./preSignPreview.vue?vue&type=template&id=a208610e&scoped=true"
import script from "./preSignPreview.vue?vue&type=script&lang=js"
export * from "./preSignPreview.vue?vue&type=script&lang=js"
import style0 from "./preSignPreview.vue?vue&type=style&index=0&id=a208610e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a208610e",
  null
  
)

export default component.exports